export class ReportInformationResponse {
    countryName: string;
    domicileId: number;
    domicileStatus: number;
    filingDate: string;
    prepareByDate: string;
    isoCode: string;
    jurisdictionId: number;
}